<template lang="pug">
	div.container-fluid
		.card
			.card-header.bg-info.text-white
				span.fa.fa-plane.mr-2
				| Vacaciones
			.card-footer
				div(style="max-width:120px;display:inline-block;")
					.input-group.input-group-sm
						.input-group-prepend
							.input-group-text Año
						.input-group-prepend.input-group-append
							button.btn.btn-primary(@click="cambiaAno(-1)")
								span.fa.fa-caret-left
						input.form-control.text-center(:disabled="true" :value="this.filtro.ano")
						.input-group-append
							button.btn.btn-primary(@click="cambiaAno(1)")
									span.fa.fa-caret-right

		Resultados.mt-2(:ano="this.filtro.ano" :empleados="empleados" :festivos="festivos" @buscar="buscar()")
</template>

<script>
import Resultados from './resultados'
import { mapGetters } from 'vuex'
import axios from 'axios'
export default {
	components: {
		Resultados
	},
	data () {
		return {
			filtro: {
				usuarios: [],
				todos: false,
				ano: new Date().getFullYear()
			},
			empleados: [],
			festivos: []
		}
	},
	computed: {
		...mapGetters({
			permisos: 'permisos/permisos',
			usuario: 'session/usuario'
		})
	},
	created () {
		this.buscar()
	},
	methods: {
		cambiaAno (inc) {
			this.filtro.ano = this.filtro.ano + inc
			this.buscar()
		},
		seleccionaUsuario (e) {
			this.usuarios.push(e.datos)
		},
		buscar () {
			axios.post('gestion-jornada/php/api/vacaciones/listado.php', {ano: this.filtro.ano})
				.then(res => {
					this.empleados = res.data.empleados
					this.festivos = res.data.festivos
				})
				.catch(this.$responseError)
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/modulos/gestion-jornada/vue/components/vacaciones/visualizar.vue